import * as React from "react";
import { withTranslation } from "react-i18next";
import { compose, pure, setDisplayName } from "recompose";
import { AppStoreLinks, Dialog, Notification } from "components";
import logoSvg from "../../assets/logo_eqwin.svg";
import { Typography } from "@material-ui/core";
export var Render = function (_a) {
    var t = _a.t;
    return React.createElement(Dialog, null,
        React.createElement("div", { style: { textAlign: "center", padding: "16px 0" } },
            React.createElement("img", { src: logoSvg, alt: window.env.COGNITO_IDENTITY_POOL_NAME, style: { maxWidth: 200, marginBottom: 24 } }),
            React.createElement(Notification, null),
            React.createElement(Typography, { style: {
                    color: "#76686A",
                    fontFamily: "Area Normal, sans-serif",
                    fontSize: 13,
                    marginBottom: 24
                } }, t("download_cta")),
            React.createElement(AppStoreLinks, null)));
};
export function enhance() {
    return compose(withTranslation(), pure, setDisplayName("RegisterVerificationSuccess"));
}
export var RegisterVerificationSuccess = enhance()(Render);
